<template>
    <HeaderVue>
        <template #header>
            <div class="item-header">
                <slot name="before">
                    <DxButton
                        class="custom-btn-white-color"
                        type="default"
                        icon="mdi mdi-chevron-left"
                        @click="$router.go(-1)"
                    />
                </slot>
            </div>
            <div class="item-header-center row justify-center">
                <slot name="center">
                    <div class="font-16 font-medium color-fff">
                        Thông tin khai báo vé
                    </div>
                </slot>
            </div>
            <div class="item-header">
                <slot name="after">
                    <div style="opacity: 0">
                        <DxButton type="default" icon="mdi mdi-cog" />
                    </div>
                </slot>
            </div>
        </template>
    </HeaderVue>

    <div class="row" style="padding-top: 48px"></div>

    <div class="mt-3 px-3">
        <ThongTinKhaiBaoVeVue />
    </div>
</template>
<script>
import HeaderVue from "@/components/Header/Header.vue";
import ThongTinKhaiBaoVeVue from "./components/ThongTinKhaiBaoVe.vue";
import { DxButton } from "devextreme-vue";
export default {
    components: {
        HeaderVue,
        DxButton,
        ThongTinKhaiBaoVeVue,
    },
    props: {},
    data() {
        return {
        };
    },
    computed: {},
    methods: {
        hiddenPopup(name) {
            this[name] = false;
        },
        showPopup(name) {
            this[name] = true;
        },
    },
    created() {},
    mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
